<template>
  <div>
    <section class="banner-wrap">
      <swiper ref="swiper" :options="bannerOption">
        <swiper-slide class="banner" v-for="(i, index) in bannerList" :key="index">
          <img :src="i.resource_url" @click="goAdvertisementDetail(i.uuid)" />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </section>
    <p class="section-title">家庭生活</p>
    <section class="home">
      <div class="item" @click="handleRoute('水費')" v-if="appConfig.water_fee_enabled">
        <img src="../assets/images/icon/waterFee@3x.png" />
        <div class="text-gray2-center">水費</div>
      </div>
      <div class="item" @click="handleRoute('電費')" v-if="supportFeatures.scanningv2 && appConfig.electricity_fee_enabled">
        <img src="../assets/images/icon/ElectronicFee@3x.png" />
        <div class="text-gray2-center">電費</div>
      </div>
      <div class="item" @click="handleRoute('瓦斯費')" v-if="supportFeatures.scanningv2 && appConfig.gas_fee_enabled">
        <img src="../assets/images/icon/GasFee@3x.png" />
        <div class="text-gray2-center">瓦斯費</div>
      </div>
      <div class="item" @click="openAutloadByOthers()" v-if="supportFeatures.supportBindAutoLoad">
        <img src="../assets/images/familyArea/autoloadByOthers.png" />
        <div class="text-gray2-center">幫家人卡片<br>自動加值</div>
      </div>
      <div class="item" v-if="appConfig.family_area_top_books_enabled !== undefined && appConfig.family_area_top_books_enabled" @click="openExternalLink('https://epkaw.easycard.com.tw/secureRedirect?link=https%3A%2F%2Fwww.books.com.tw%2Fweb%2Fsys_saletopb%2Fbooks%2F13%3Fattribute%3D7&verify=3f9ef772f728be93b3c9e19bdc1f887dfa652d2e05c6f745c6995378d3dd7a21', 'family_click_books_sys_saletopb')">
        <img src="../assets/images/familyArea/glasses.png" />
        <div class="text-gray2-center">親職悅讀</div>
      </div>
      <div class="item" v-if="appConfig.family_area_kkbox_enabled !== undefined && appConfig.family_area_kkbox_enabled"  @click="openExternalLink('/kkbox', 'family_click_kkbox')">
        <img src="../assets/images/familyArea/KKBOX.png" />
        <div class="text-gray2-center">KKBOX<br>家庭方案</div>
      </div>
      <div class="item" v-if="appConfig.family_area_traiwan_enabled !== undefined && appConfig.family_area_traiwan_enabled"  @click="openExternalLink('https://epkaw.easycard.com.tw/secureRedirect?link=https%3A%2F%2Ftraiwan.com%2Fchannel%2Fuupay%2F&verify=d57fbb531dd34f85f97375b7e46372d01f34ed9f68070ff860d7404d4452add3', 'family_click_traiwan')">
        <img src="../assets/images/familyArea/suitcase.png" />
        <div class="text-gray2-center">親子旅遊</div>
      </div>
      <div class="item" v-if="appConfig.family_area_maobao_enabled !== undefined && appConfig.family_area_maobao_enabled"  @click="openExternalLink('https://epkaw.easycard.com.tw/secureRedirect?link=https%3A%2F%2Fwww.maobao2.com.tw%2F&verify=b8647acf021dc0fc7b48fcd994456687489a01d0807137786c6ab716b13f6378', 'family_click_maobao')">
        <img src="../assets/images/familyArea/cleaner.png" />
        <div class="text-gray2-center">居家清潔</div>
      </div>
      <div class="item" @click="openExternalLink('https://www.easycard.com.tw/offer?cls=1506473503,&id=1672021201', 'family_click_daycare_subsidy')">
        <img src="../assets/images/familyArea/babyCarring.png" />
        <div class="text-gray2-center">育兒補助申請</div>
      </div>
      <div class="item" @click="openExternalLink('https://epkaw.easycard.com.tw/secureRedirect?link=https%3A%2F%2Fborn.taipei%2Fcp.aspx%3Fn%3D4BB21D19B8E70CE0&verify=5f3858f9425f2a63ccfb8e38683f366558628a471b328c9e828e6df3eb3ceb8c', 'family_click_born_taipei')">
        <img src="../assets/images/familyArea/pregnant.png" />
        <div class="text-gray2-center">生育補助申請</div>
      </div>
    </section>

    <p class="section-title-below">教育學習</p>
    <section class="home">      
      <div
        class="item"
        @click="handleRoute('學雜費', 'click_tuition_fee')"
        v-if="
          sessionTuitionPayment === true || sessionTuitionPayment === 'true' || supportFeatures.tuition === true || supportFeatures.tuition === 'true'
        "
      >
        <img src="../assets/images/icon/Tuition@3x.png" />
        <div class="text-gray2-center">學雜費</div>
      </div>
      <div class="item" v-if="appConfig.family_area_books_crosscat_enabled !== undefined && appConfig.family_area_books_crosscat_enabled"  @click="openExternalLink('https://epkaw.easycard.com.tw/secureRedirect?link=https%3A%2F%2Factivity.books.com.tw%2Fcrosscat%2Fshow%2FA00000003004&verify=59231a5fbc429b33efbf04fc3fcdac3472dcd759de85c6e923703342221c8509', 'family_click_books_crosscat_show')">
        <img src="../assets/images/familyArea/prize.png" />
        <div class="text-gray2-center">青春排行榜</div>
      </div>
      <div class="item" v-if="appConfig.family_area_books_essay_enabled !== undefined && appConfig.family_area_books_essay_enabled"  @click="openExternalLink('https://epkaw.easycard.com.tw/secureRedirect?link=https%3A%2F%2Fireader.books.com.tw%2Fessay_event&verify=ed16636d7a3f22bf6f48983fef9e00dc60b831fa7d34816095f0328eff0e8d75', 'family_click_books_essay_event')">
        <img src="../assets/images/familyArea/announce.png" />
        <div class="text-gray2-center">青春佈告欄</div>
      </div>
      <div class="item" v-if="appConfig.family_area_books_category_enabled !== undefined && appConfig.family_area_books_category_enabled"  @click="openExternalLink('https://epkaw.easycard.com.tw/secureRedirect?link=https%3A%2F%2Fokapi.books.com.tw%2Fcategory%2F138&verify=919c3ac4725f5bfc7b5e1f968d7a79316a93b0f630223e640a5618270f363636', 'family_click_books_category')">
        <img src="../assets/images/familyArea/featherPen.png" />
        <div class="text-gray2-center">青春一起讀</div>
      </div>
    </section>
    <transition>
      <section v-show="dialogList.length !== 0">
        <div class="bottom-dialog" :class="dialogOpen ? 'up' : 'down'">
          <div class="title-wrap">
            <div class="title">{{ dialogList.title }}</div>
            <div class="icon-cancel" @click="closeBottomDialog"></div>
          </div>

          <div ref="bottomDialogContent" class="bottom-dialog-content" :class="dialogBorder ? 'dialog-navbar' : ''">
            <div @click="handleChildRoute(child)" v-for="child in dialogList.child" :key="child.path">
              <div class="block" v-show="child.show">
                <img v-show="child.icon" :src="child.icon" />
                <div>
                  <div class="text-gray2">{{ child.title1 }}</div>
                  <div :class="child.path === '/carPark' ? '' : 'text-nowrap'">{{ child.title2 }}</div>
                </div>
                <span class="arrow-right"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="mask"></div>
      </section>
    </transition>
    <!-- <div style="margin: 20px">
      <li>{{ $route.query.k }}</li>
      <li>{{ $route.query.p }}</li>
    </div>-->
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import { mapGetters, mapActions } from 'vuex';
import { getBanner, getConfig } from '../api/api';

export default {
  name: 'family-area',
  components: {
    Swiper,
    SwiperSlide,
  },
  metaInfo() {
    return { 
      title: "親子專區",      
      meta: [
        { name: 'og:title', content: '親子專區' }
      ],
    }
  },
  data() {
    return {
      active: 0,
      bannerList: [],
      bannerOption: {
        initialSlide: 0,
        autoplay: { delay: 5000, disableOnInteraction: false },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
      appConfig: {
        tuition_fee_enabled: false,
      },      
      dialogList: [],
      dialogOpen: false,
      dialogBorder: false,
      openDialog: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path !== '/') {
        vm.openDialog = false;
      } else {
        vm.openDialog = true;
      }
    });
  },
  mounted() {
    this.getBaseConfig();
    this.$refs.bottomDialogContent.addEventListener('scroll', this.dialogScroll);
  },
  destroyed() {
    this.$refs.bottomDialogContent.removeEventListener('scroll', this.dialogScroll);
  },
  computed: {
    ...mapGetters(['sessionTuitionPayment', 'supportFeatures', 'sessionKey', 'sessionToken']),
    isTuitionFeeEnabled() {
      return this.appConfig.tuition_fee_enabled;
    },
    list() {
      return [       
        {
          condition: true,
          title: '水費',
          img: require('../assets/images/icon/waterFee@3x.png'),
          path: '',
          child: [
            {
              path: '/taipeiWaterFee',
              title1: '',
              title2: '臺北市自來水事業處',
              show: true,
              eventName: 'family_click_water_fee',
            },
            {
              path: '/taiwanWaterFee',
              title1: '',
              title2: '台灣自來水公司',
              show: true,
              eventName: 'family_click_water_fee',
            },
          ],
        },
        {
          condition: true,
          title: '電費',
          img: require('../assets/images/icon/ElectronicFee@3x.png'),
          path: '/electronicFee',
          eventName: 'family_click_taipower_fee',
          child: [],
        },
        {
          condition: true,
          title: '瓦斯費',
          img: require('../assets/images/icon/GasFee@3x.png'),
          path: '/gasFee',
          eventName: 'family_click_gas_fee',
          child: [],
        },
        {
          condition: true,
          title: '有線電視費',
          img: require('../assets/images/icon/TvFee@3x.png'),
          path: '/tvFee',
          eventName: 'click_cabletv_fee',
          child: [],
        },
        {
          condition: true,
          title: '學雜費',
          img: require('../assets/images/icon/Tuition@3x.png'),
          path: '',
          eventName: '',
          child: [
            {
              path: '/taipeiCityTuitionFee',
              title1: '',
              title2: '台北市立學校與親子綁定',
              show: true,
              eventName: 'family_click_bill_payment_schoolfee',
            },
            {
              path: '/newTaipeiCityTuitionFee',
              title1: '',
              title2: '新北市立學校與親子綁定',
              show: this.isTuitionFeeEnabled,
              eventName: 'click_tuition_fee',
            },
            {
              path: '/otherTuitionFee',
              title1: '',
              title2: '其他學校',
              show: this.isTuitionFeeEnabled,
              eventName: 'family_click_bill_payment_schoolfee',
            },
          ],
        },      
      ];
    }
  },
  watch: {
    'supportFeatures.scanningv2'() {
      if (!this.$route.query.localtaxMenu) {
        this.handleLocaltaxList();
      }
    },
  },
  methods: {
    ...mapActions(['sentApp']),
    goPaymentList() {
      alert('建置中');
    },
    openAutloadByOthers() {
      this.sentApp({
            action: 'sendFirebaseEvent',
            payload: { event: 'family_click_enable_autoload' },
          });
      this.sentApp({
        action: 'bindAutoLoad',
        payload: {},
      });
    },
    openExternalLink(url, firebaseEventName) {
      if (!url.startsWith('http') && location.host.endsWith('easycard.com.tw')) {
        url = 'https://' + location.host + url;
      }
      if (firebaseEventName !== null) {
        this.sentApp({
              action: 'sendFirebaseEvent',
              payload: { event: firebaseEventName },
            });
      }
      this.sentApp({
        action: 'openExternalBrowser',
        payload: { url: url },
      });
    },
    handleRoute(type) {
      this.list.forEach((i) => {
        if (i.title === type) {
          if (i.child.length !== 0) {
            this.dialogList = i;
            this.dialogOpen = true;
          } else {
            this.$router.push(i.path);
            this.sentApp({
              action: 'sendFirebaseEvent',
              payload: { event: i.eventName },
            });
          }
        }
      });
    },
    handleChildRoute(child) {
      this.sentApp({
        action: 'sendFirebaseEvent',
        payload: { event: child.eventName },
      });
      if (child.code === 'TYN') {
        var alertMessage = '您即將離開 Easy Wallet App 到「桃園市市民卡 App」繳費。';
        this.sentApp({
          action: 'showNoChildrenDataDialog',
          payload: {
            title: alertMessage,
            button0: '確認',
            button1: '取消',
            externalUrl: child.path,
          },
        });
      } else {
        this.$router.push({ path: child.path, query: { title: child.title2, code: child.code } });
      }
    },
    async getBaseConfig() {
      await getBanner().then((res) => {
        if (res !== undefined && (res.error === null || res.error === undefined) && res.data.hasOwnProperty('12')) {
          this.bannerList = res.data['12'];
        }
      });
      await getConfig({}).then((res) => {
        if (res !== undefined && res.error === undefined) {
          this.appConfig = res;
        }
      });
    },
    closeBottomDialog() {
      this.dialogOpen = false;
      setTimeout(() => {
        this.dialogList = [];
      }, 200);
    },
    dialogScroll() {
      let scrollTop = this.$refs.bottomDialogContent.scrollTop;
      if (scrollTop > 0) {
        this.dialogBorder = true;
      } else {
        this.dialogBorder = false;
      }
    },
    goAdvertisementDetail(uuid) {
      this.sentApp({
        action: 'sendFirebaseEvent',
        payload: { 
          event: 'click_ad_family' , 
          payload: { advertisement_uuid: uuid} 
        },
      });      
      this.sentApp({
        action: 'showAdvertisementDetail',
        payload: { uuid: uuid },
      });
    },
  },
};
</script>
<style type="text/scss" lang="scss" scoped>

.section-title {
  font-size: 14px;
  color: rgba(64, 64, 64, 0.75);
  margin: 12px 20px;
}

.section-title-below {
  font-size: 14px;
  color: rgba(64, 64, 64, 0.75);
  margin: 32px 20px 12px 20px;
}

.swiper-pagination {
  position: relative;
  left: 0;
  top: 0;
}

.swiper-container {
  --swiper-theme-color: rgb(64, 64, 64);
}

.banner-wrap {
  padding: 20px;

  .banner {
    img {
      border-radius: 8pt;
      object-position: center;
      width: 100%;
    }
  }
}

.home {
  background: #fff;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.block {
  background-color: #fff;
  border-radius: 8px;
  margin: 0 20px 16px 20px;
  padding: 20px;
  font-size: 16px;
  display: flex;
  align-items: center;
  box-shadow: 0 4pt 8pt 0 rgba(0, 0, 0, 0.05);
}

.block img {
  width: 44px;
  height: 44px;
  margin-right: 16pt;
}

.arrow-right {
  margin-left: auto;
}

.block-shadows {
  background: #fff;
  margin: 26pt 20pt 24pt 20pt;
  padding-right: 7.3pt;
  font-size: 20px;
  display: flex;
  align-items: center;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.05);
}

.block-shadows img {
  width: 96px;
}

.text-gray2-center {
  font-size: 14px;
  margin-bottom: 2pt;
  text-align: center;
}

.text-gray2 {
  font-size: 14px;
  margin-bottom: 2pt;
  min-width: 90px;
}

.barge {
  background: #e7007f;
  color: #fff;
  border-radius: 12pt;
  font-size: 16px;
  padding: 3px 8px;
  margin-left: auto;
}
.block:active,
.block-shadows:active {
  background: rgba(0, 0, 0, 0.05);
}

.item {
  border-radius: 8px;
  padding: 14pt 12pt;
  font-size: 13px;
  display: flex;
  align-items: center;
  flex-direction: column;

  & img {
    width: 44px;
    height: 44px;
  }
}

.up {
  animation: slideUp 0.3s ease-in-out both;
}

.down {
  animation: slideDown 0.3s ease-in-out both;
}

@keyframes slideUp {
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes slideDown {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(100%);
  }
}

/*.v-leave {
  opacity: 1;
}
.v-leave-active {
  transition: opacity 0.1s;
}
.v-leave-to {
  opacity: 0;
}
.v-enter {
  opacity: 0;
}
.v-enter-active {
  transition: opacity 0.1s;
}
.v-enter-to {
  opacity: 1;
}*/
</style>
